import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28,12H24L20.58,7a2,2,0,0,0-1.74-1H6.32A2,2,0,0,0,4.48,7.21L2.22,11.57a2.08,2.08,0,0,0-.22.92V20a2,2,0,0,0,2,2H6a2,2,0,0,1,4,0H22a2,2,0,0,1,4,0h2a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Zm-16-.5a.5.5,0,0,1-.5.5H4.81a.5.5,0,0,1-.45-.72l1.5-3A.51.51,0,0,1,6.31,8H11.5a.5.5,0,0,1,.5.5Zm8.19.5H14.5a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h4.19a.51.51,0,0,1,.45.28l1.5,3A.5.5,0,0,1,20.19,12Z"/><path d="M24,24a2,2,0,0,1-2-2H20a4,4,0,0,0,8,0H26A2,2,0,0,1,24,24Z"/><path d="M8,24a2,2,0,0,1-2-2H4a4,4,0,0,0,8,0H10A2,2,0,0,1,8,24Z"/>';
export var CarSideSVG = function CarSideSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CarSideSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CarSideSVG);